import { isObject } from "lodash";
import { Block } from "../objects/block";

export function isBlock(instance: unknown): instance is Block<any> {
    return isObject(instance) && !!(instance as any).getType;
}
